module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-components/category-menu-items/category-menu-items.component.scss
// module id = ./src/app/ui-components/category-menu-items/category-menu-items.component.scss
// module chunks = main